import React, { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { createEnvelope, updateEnvelope } from "../../../../services/CommonService";
import { toast } from "react-toastify";
import Utils from "../../../../utils";
import DatePicker from "react-datepicker";
import { DATE_FORMAT_LIST } from "../../../../configs/AppConfig";
import '../../../../assets/sleeve.css';
import Select from 'react-select';

function EnvelopeStep1(props) {
  const navigate = useNavigate();
  const [pastDate, setPastDate] = useState(new Date());
  const [senderList, setSenderList] = useState([]);
  const [envelopeSenderId, setEnvelopeSenderId] = useState(0);
  const [envelopeName, setEnvelopeName] = useState('');
  const [envelopeDate, setEnvelopeDate] = useState('');
  const [clientMessage, setClientMessage] = useState('');
  const [isSmartSleeve, setIsSmartSleeve] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [selectedSleeveType, setSelectedSleeveType] = useState(false);
  const [hoveredSleeveType, setHoveredSleeveType] = useState(null);

  const dueDateRef = useRef(null);

  let errorsObj = {
    sender_id: '',
    envelope_name: '',
    envelope_date: '',
    client_message: '',
  };
  const [errors, setErrors] = useState(errorsObj);

  function getInitials(firstName, lastName) {
    if (!firstName && !lastName) return '';
    return ((firstName ? firstName[0] : '') + (lastName ? lastName[0] : '')).toUpperCase();
  }

  useEffect(() => {
    if (!props.formObj.envelope_id || props.formObj.envelope_id == 0) {
      setShowModal(true);
    }
  }, []);

  useEffect(() => {
    if (showModal) {
      const timer = setTimeout(() => {
        const backdrops = document.querySelectorAll('.offcanvas-backdrop');
        backdrops.forEach(backdrop => {
          backdrop.remove();
        });
        document.body.style.overflow = 'auto';
        document.body.classList.remove('offcanvas-open');
        document.body.classList.remove('modal-open');
      }, 50);

      return () => clearTimeout(timer);
    }
  }, [showModal]);

  useEffect(() => {
    setPastDate(Utils.pastDate());

    if (props?.senderList.length > 0) {
      setSenderList(props.senderList);
    }

    let initialSenderId = props.formObj.sender_id || 0;
    if (!initialSenderId && props?.senderList.length > 0) {
      let index = props?.senderList.findIndex(x => x.is_login_user === true);
      if (index > -1) {
        initialSenderId = props.senderList[index]['id'];
      }
    }
    setEnvelopeSenderId(Number(initialSenderId));

    setEnvelopeName(props.formObj.envelope_name || '');
    setEnvelopeDate(props.formObj.envelope_date || '');
    setClientMessage(props.formObj.client_message || '');
    setIsSmartSleeve(props.formObj.is_smart_sleeve || false);
    setSelectedSleeveType(props.formObj.is_smart_sleeve || false);
  }, [props]);

  function onBack(e) {
    e.preventDefault();
    navigate('/client-portal');
  }

  function onSaveExit(e) {
    e.preventDefault();
    onSubmitForm(1);
  }

  function onNext(e) {
    e.preventDefault();
    onSubmitForm(2);
  }

  function onSubmitForm(type) {
    let error = false;
    const errorObj = { ...errorsObj };
    if (!envelopeSenderId) {
      errorObj.sender_id = 'Please select sender';
      error = true;
    }
    if (!envelopeName) {
      errorObj.envelope_name = 'Sleeves name must be required';
      error = true;
    }
    if (!envelopeDate) {
      errorObj.envelope_date = 'Please select date';
      error = true;
    }
    if (!clientMessage) {
      errorObj.client_message = 'Please enter message';
      error = true;
    }

    setErrors(errorObj);

    if (error) return;

    const formData = { ...props.formObj };

    let obj = {
      sender_id: envelopeSenderId,
      envelope_name: envelopeName,
      due_date: envelopeDate,
      message: clientMessage,
      is_smart_sleeve: isSmartSleeve,
    };

    props.setLoading(true);
    if (formData.envelope_id > 0) {
      obj['envelope_id'] = formData.envelope_id;
      updateEnvelope(obj)
        .then(response => {
          if (type === 2) {
            formData.current_step = 2;
            formData.sender_id = envelopeSenderId;
            formData.envelope_name = envelopeName;
            formData.envelope_date = envelopeDate;
            formData.client_message = clientMessage;
            formData.is_smart_sleeve = isSmartSleeve;
            props.setFormObj(formData);
            const nextRoute = isSmartSleeve
              ? `/client-portal/sleeve/edit-smart/${formData.envelope_uuid}/2`
              : `/client-portal/sleeve/edit/${formData.envelope_uuid}/2`;
            navigate(nextRoute);
          } else {
            navigate('/manage/draft');
          }
          toast.success(response.data.message);
          props.setLoading(false);
        })
        .catch(err => {
          toast.error(Utils.getErrorMessage(err));
          props.setLoading(false);
        });
    } else {
      obj['send_reminder'] = formData.send_reminder;
      obj['over_due_reminder'] = formData.over_due_reminder;
      createEnvelope(obj)
        .then(response => {
          if (type === 2) {
            formData.envelope_id = response.data.id;
            formData.envelope_uuid = response.data.uuid;
            formData.current_step = 2;
            formData.sender_id = envelopeSenderId;
            formData.envelope_name = envelopeName;
            formData.envelope_date = envelopeDate;
            formData.client_message = clientMessage;
            formData.is_smart_sleeve = isSmartSleeve;
            props.setFormObj(formData);
            const nextRoute = isSmartSleeve
              ? `/client-portal/sleeve/edit-smart/${response.data.uuid}/2`
              : `/client-portal/sleeve/edit/${response.data.uuid}/2`;
            navigate(nextRoute);
          } else {
            navigate('/client-portal');
          }
          toast.success(response.data.message);
          props.setLoading(false);
        })
        .catch(err => {
          toast.error(Utils.getErrorMessage(err));
          props.setLoading(false);
        });
    }
  }

  const handleSleeveSelection = () => {
    setIsSmartSleeve(selectedSleeveType);
    props.setFormObj({
      ...props.formObj,
      is_smart_sleeve: selectedSleeveType
    });
    setShowModal(false);
    document.body.classList.remove('modal-open');
    const backdrop = document.querySelector('.modal-backdrop');
    if (backdrop) {
      backdrop.remove();
    }
  };

  const handleCloseModal = () => {
    setShowModal(false);
    navigate('/client-portal');
    document.body.classList.remove('modal-open');
    const backdrop = document.querySelector('.modal-backdrop');
    if (backdrop) {
      backdrop.remove();
    }
  };

  const handleRadioChange = (isSmart) => {
    setSelectedSleeveType(isSmart);
  };

  const showDate = (date) => {
    let dateFormat = '';
    if (date) {
      dateFormat = new Date(date);
    }
    return dateFormat;
  };

  const showDateFormat = (id) => {
    let value = '';
    let index = DATE_FORMAT_LIST.findIndex(x => parseInt(x.id) === parseInt(id));
    if (index > -1) {
      value = DATE_FORMAT_LIST[index]['format'];
    }
    return value;
  };

  const showDatePlaceholder = (id) => {
    let value = '';
    let index = DATE_FORMAT_LIST.findIndex(x => parseInt(x.id) === parseInt(id));
    if (index > -1) {
      value = DATE_FORMAT_LIST[index]['text'];
    }
    return value;
  };

  const senderOptions = senderList.map(item => ({
    value: Number(item.id),
    label: `${item.first_name} ${item.last_name} (${item.email})`,
    data: item,
  }));
  const selectedSenderOption = senderOptions.find(opt => opt.value === Number(envelopeSenderId)) || null;


  return (
    <>
      <div
        className={`modal step1-modal fade sleeve ${showModal ? "show" : ""}`}
        data-bs-backdrop="false"
        style={{ display: showModal ? "block" : "none" }}
      >
        <div
          className="modal-dialog modal-lg modal-dialog-centered step1-modal-dialog"
          role="document"
        >
          <div className="modal-content step1-modal-content">
            <div className="modal-header border-0 step1-modal-header">
              <div>
                <h5
                  className="modal-title step1-modal-title"
                  id="sleeveModalLabel"
                >
                  Choose Your Vibe ✨
                </h5>
                <p className="step1-modal-subtitle">Pick what works for you</p>
              </div>
              <button
                type="button"
                className="btn-close step1-modal-close"
                onClick={handleCloseModal}
                aria-label="Close"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="#6B7280"
                  viewBox="0 0 16 16"
                >
                  <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z" />
                </svg>
              </button>
            </div>
            <div className="modal-body step1-modal-body">
              <div className="step1-sleeve-cards">
                <div
                  className={`card step1-sleeve-card${selectedSleeveType === false ? " active" : ""
                    }`}
                  onClick={() => handleRadioChange(false)}
                >
                  <div className="form-check d-flex justify-content-between p-0">
                    <div>
                      <label
                        className="form-check-label fw-bold step1-sleeve-label"
                        htmlFor="normalSleeve"
                      >
                        Normal Sleeve
                      </label>
                      <span className="rounded-pill step1-sleeve-badge">
                        Clean & Simple
                      </span>
                      <p className="step1-sleeve-desc">
                        Keep it minimal - all your files in one organized list
                      </p>
                    </div>
                    <div>
                      <div
                        className={`step1-radio${selectedSleeveType === false ? " checked" : ""
                          }`}
                      >
                        {selectedSleeveType === false && (
                          <div className="step1-radio-dot" />
                        )}
                      </div>
                    </div>
                  </div>
                </div>
                {/* Smart Sleeve */}
                <div
                  className={`card step1-sleeve-card${selectedSleeveType === true ? " active" : ""
                    }`}
                  onClick={() => handleRadioChange(true)}
                >
                  <div className="form-check d-flex justify-content-between p-0">
                    <div>
                      <label
                        className="form-check-label fw-bold step1-sleeve-label"
                        htmlFor="smartSleeve"
                      >
                        Smart Sleeve ✨
                      </label>
                      <span className="rounded-pill step1-sleeve-badge smart">
                        AI Powered
                      </span>
                      <p className="step1-sleeve-desc">
                        Let AI organize everything for you automatically
                      </p>
                    </div>
                    <div>
                      <div
                        className={`step1-radio${selectedSleeveType === true ? " checked" : ""
                          }`}
                      >
                        {selectedSleeveType === true && (
                          <div className="step1-radio-dot" />
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="modal-footer border-0 step1-modal-footer">
              <button
                type="button"
                className="btn w-100 step1-modal-go"
                onClick={handleSleeveSelection}
              >
                Let's Go! 🚀
              </button>
            </div>
          </div>
        </div>
      </div>

      <div className="sleeve-gradient-bg sleeve-step">
        <div className="sleeve-main-card">
          {selectedSleeveType === true ? (
            <>
              <h1 className="sleeve-title">Smart Sleeve ✨</h1>
              <p className="sleeve-subtitle">
                Let AI organize everything for you automatically
              </p>
            </>
          ) : (
            <>
              <h1 className="sleeve-title">Sleeves Details</h1>
              <p className="sleeve-subtitle">
                Keep it minimal - all your files in one organized list
              </p>
            </>
          )}

          {/* Sender Section */}
          <div className="sleeve-sender-card">
            <h2 className="sleeve-heading">
              <i className="bi bi-person" />
              <span>
                Your Email Address (Sender)
                <i
                  className="bi bi-info-circle ms-1 text-muted cursor-pointer fs-6"
                  aria-hidden="true"
                  data-toggle="tooltip"
                  data-placement="left"
                  title="This is the email used to send the document request. You can select from your verified addresses."
                />
              </span>
            </h2>
            <Select
              classNamePrefix="sleeve-sender-select"
              value={selectedSenderOption}
              onChange={(option) =>
                setEnvelopeSenderId(option ? Number(option.value) : 0)
              }
              options={senderOptions}
              placeholder="Select sender"
              isSearchable
              formatOptionLabel={(option) => (
                <div className="sleeve-sender-option">
                  <div className="sleeve-sender-initials">
                    {getInitials(option.data.first_name, option.data.last_name)}
                  </div>
                  <div>
                    <div className="sleeve-sender-name">
                      {option.data.first_name} {option.data.last_name}
                    </div>
                    <div className="sleeve-sender-email">
                      {option.data.email}
                    </div>
                  </div>
                </div>
              )}
              styles={{}}
            />
            {errors.sender_id && (
              <div className="error-message">{errors.sender_id}</div>
            )}
          </div>

          {/* Form Section */}
          <div className="sleeve-sender-card">
            <div className="row g-3">
              {/* Sleeves Name */}
              <div className="col-lg-7">
                <label className="sleeve-step-label">
                  Request Title / Folder Name (Sleeve Name)
                  <i
                    className="bi bi-info-circle ms-1 text-muted cursor-pointer"
                    aria-hidden="true"
                    data-toggle="tooltip"
                    data-placement="right"
                    title={
                      'Name this document request for easy identification later. Example: "IT Returns 2025" or "Loan Docs - March."'
                    }
                  />
                </label>
                <input
                  type="text"
                  className={`sleeve-step-input ${errors.envelope_name ? "input-error" : ""
                    }`}
                  placeholder="Enter sleeve name"
                  value={envelopeName}
                  onChange={(e) => setEnvelopeName(e.target.value)}
                />
                {errors.envelope_name && (
                  <div className="input-error-message">
                    {errors.envelope_name}
                  </div>
                )}
              </div>
              {/* Due Date */}
              <div className="col-lg-5">
                <label className="sleeve-step-label">
                  Submission Deadline (Due Date)
                  <i
                    className="bi bi-info-circle ms-1 text-muted cursor-pointer"
                    aria-hidden="true"
                    data-toggle="tooltip"
                    data-placement="right"
                    title="The recipient should upload all requested documents by this date. Optional, but helps set expectations."
                  />
                </label>
                <div className="position-relative">
                  <DatePicker
                    ref={dueDateRef}
                    selected={showDate(envelopeDate)}
                    onChange={(date) => setEnvelopeDate(date)}
                    minDate={pastDate}
                    dateFormat={showDateFormat(1)}
                    placeholderText="dd-mm-yyyy"
                    className={`sleeve-step-input ${errors.envelope_date ? "input-error" : ""
                      }`}
                  />
                  <i
                    className="bi bi-calendar"
                    style={{
                      position: "absolute",
                      right: "16px",
                      top: "50%",
                      transform: "translateY(-50%)",
                      cursor: "pointer",
                      color: "#888",
                    }}
                    onClick={() => dueDateRef?.current.setFocus(true)}
                  />
                </div>
                {errors.envelope_date && (
                  <div className="input-error-message">
                    {errors.envelope_date}
                  </div>
                )}
              </div>
            </div>
          </div>
          <div className="sleeve-sender-card">
            {/* Client Portal Message */}
            <div className="mt-3">
              <label className="sleeve-step-label">
                Custom Message to Recipient (Client Portal Message)
                <i
                  className="bi bi-info-circle ms-1 text-muted cursor-pointer"
                  aria-hidden="true"
                  data-toggle="tooltip"
                  data-placement="right"
                  title="This message is shown to the recipient. Use it to explain what documents you need and any special instructions."
                />
              </label>
              <textarea
                className="sleeve-step-textarea"
                rows={10}
                value={clientMessage}
                onChange={(e) => setClientMessage(e.target.value)}
                placeholder="Enter your message"
              />
              {errors.client_message && (
                <div className="error-message">{errors.client_message}</div>
              )}
            </div>
          </div>
          {/* Buttons */}
          <div className="sleeve-step-buttons">
            <div>
              <button className="sleeve-btn-back" onClick={onBack}>
                Back
              </button>
            </div>
            <div className="sleeve-step-buttons-right">
              <button className="sleeve-btn-save" onClick={onSaveExit}>
                Save & Exit
              </button>
              <button className="sleeve-btn-next" onClick={onNext}>
                Next
              </button>
            </div>
          </div>
        </div>
      </div>
      {/* <div className="step_wizard_button shadow">
          <button type="button" onClick={onBack} className="btn btn_outline">
            Back
          </button>
          <button
            type="button"
            onClick={onSaveExit}
            data-toggle="tooltip"
            title={Lang.env_save_exit}
            className="btn btn_outline"
            style={{ margin: "0 10px" }}
          >
            Save & Exit
          </button>
          <button type="button" onClick={onNext} className="btn btn-primary">
            Next
          </button>
        </div> */}
    </>
  );
}

export default EnvelopeStep1;

